<template>
  <f7-popup id="service-activation">

		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Service Enroll" :closePopup="true"></page-nav-bar>

    <div class="layoutSubtitle"/>
    <f7-list form>
      <f7-list-item divider>Informations</f7-list-item>
      <f7-list-item >{{currentService.name}}</f7-list-item>
      <f7-list-item>{{currentService.price + currentService.device}}</f7-list-item>
      <f7-list-item>{{currentService.date}}</f7-list-item>
      <f7-list-item divider>Payments</f7-list-item>
      <f7-list-item>
        <f7-label>Select month</f7-label>
        <f7-input type="select" v-model="subscribeMounth" @change="reloadInformation">
              <option class="displayInDroplist" v-for="n in 12" :value="n">{{n}}</option>
        </f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Credit card</f7-label>
        <f7-input name="creditCard" placeholder="0000-0000-0000-0000" type="text" v-model="creditCard"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Expiration date</f7-label>
        <f7-input name="expirationDate" placeholder="1900-01-01" type="text" v-model="expirationDate"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Secure code</f7-label>
        <f7-input name="secureCode" placeholder="0000" type="text" v-model="secureCode"></f7-input>
      </f7-list-item>
    </f7-list>
    <f7-button icon-f7="compose" title="Enroll" class="blueConfirmationButton" @click="registerService()" close-popup>Enroll</f7-button>
  </f7-popup>
</template>

<script>
import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'

export default {
  name: 'ServiceActivationPopUp',
  components: {
    'page-nav-bar': pageNavBar
  },
  data: () => {
    return {
      currentService: {},
      subscribeMounth: 1,
      creditCard: '',
      expirationDate: '',
      secureCode: ''
    }
  },
  mounted () {
  },
  updated () {
  },
  created () {
    this.$bus.$on('buyService', (currentService) => {
      this.currentService = currentService
      this.currentService.priceByMonth = currentService.price
      this.currentService.price = currentService.price
      this.currentService.active = currentService.active
      if (this.currentService.active === '0') {
        this.currentService.date = this.getNextDateFromToday(1)
      } else {
        this.currentService.dateOri = this.getNextDateFromDate(currentService.date, 0)
        this.currentService.date = this.getNextDateFromDate(currentService.date, 1)
      }
    })
  },
  beforeDestroy () {
  },
  methods: {
    getNextDateFromToday (addMonth) {
      return moment().add(parseInt(addMonth), 'M').format('YYYY-MM-DD')
    },
    getNextDateFromDate (date, addMonth) {
      return moment(date).add(parseInt(addMonth), 'M').format('YYYY-MM-DD')
    },
    reloadInformation () {
      this.currentService.price = this.currentService.priceByMonth * this.subscribeMounth
      if (this.currentService.active === '0') {
        this.currentService.date = this.getNextDateFromToday(this.subscribeMounth)
      } else {
        this.currentService.date = this.getNextDateFromDate(this.currentService.dateOri, this.subscribeMounth)
      }
    },
    registerService () {
      const that = this
      this.$engine.services
        .enroll(this.currentService.id, moment(this.currentService.date, 'YYYY-MM-DD'))
        .then(response => {
          this.status = response.status
          if (response.status === 200) {
            // Update cache settings
            // for (var appli = 0; appli < that.$settings.currentAccount.applications.length; appli++) {
            //   if (that.$settings.currentAccount.applications[appli].id === this.currentService.id) {
            //     that.$settings.currentAccount.applications[appli].date = this.currentService.date
            //     that.$settings.currentAccount.applications[appli].active = '1'
            //   }
            // }
            that.$engine.services.get()[that.currentService.id - 1].active = '1'
            that.$engine.services.get()[that.currentService.id - 1].date = this.currentService.date
            this.subscribeMounth = 1
            // this.$bus.$emit('refresh-cache-service')
            this.$f7.alert('', 'Your subscribtion is validated')
          }
        }).catch(error => {
          errorMessageAlert(error, that)
        })
    }
  }
}
</script>

<style>
.list-block {
  padding: 0px 0px 0px 0px;
  margin: 0px 0px 0px 0px;
}
.list-block .item-title.label{
  width: 40;
}
</style>
